const state = {
    param: {
        sectionArr: [],    // ppt的内容
      currentIndex: 0    // ppt的内容
    },
    knowledgePoints: [], // 存放选择知识点
    targetList: [],   //最后选中教学目标
    mTeachingDesignId: '', //教学设计id
    defaultTargetListByPrivate: [], //完全符合默认教案的教学目标
    referenceFlag: 0,                //判断是否为参考教学设计进入编辑页
    adjustmentFlag: 0,                //判断是否为调整进入页面
    otherCourseFlag: 0,                //判断是否在其他课程下点击进入
    hiddenFlag: 0,                     //判断tab3页面显示隐藏flag
    oldData: '',                       //教学目标oldData
    newData: '',                        //教学目标newData
    oldSectionExportConfigData: '',
    newSectionExportConfigData: '',
    oldSectionData: '',                 //PPT page oldData
    newSectionData: '',                 //PPT page newData
    oldSectionPPtData: '',                //PPT page展示oldData
    newSectionPPtData: '',                //PPT page展示newData
    adjustmentSaveFlag: 0,                 //调整进入页面切换tab保存设计教学过程可以进行保存
    giveLessonsFlag:false,                 //一键授课
    designIntentShowFlag:false,            //全局教学设计
    d201courseId:'',
    d201typeId: 0,
    classId:''                             //存储测评管理班级id 跳转页面放在classId重置
}
const mutations = {
    saveClass:(state,value) =>{
        state.classId = value
    },
    saveHWCourseId:(state,value) =>{
      state.d201courseId = value
    },
    saveHWTypeId:(state,value) =>{
        state.d201typeId = value
    },
    saveDesignIntentShowFlag:(state,value) => {
      state.designIntentShowFlag = value;
    },
    // 另存时用
    saveAsSections_store: (state, sectionArr) => {
        state.param.sectionArr = sectionArr;
    },
    saveSections_store: (state, sectionArr) => {
        state.param.sectionArr = sectionArr;
    },
    clearSections_store: (state) => {
        state.param.sectionArr.length = 0;
    },
    saveCurrentIndex: (state, currentIndex) => {
      state.param.currentIndex = currentIndex;
    },
    saveKnowledgePoints: (state, knowledgePoints) => {
        state.knowledgePoints = knowledgePoints;
    },
    saveOldData: (state, data) => {
        state.oldData = data
    },
    saveNewData: (state, data) => {
        state.newData = data
    },
    saveOldSectionExportConfigData: (state, data) => {
        state.oldSectionExportConfigData = data
    },
    saveNewSectionExportConfigData: (state, data) => {
        state.newSectionExportConfigData = data
    },
    saveOldSectionData: (state, data) => {
        state.oldSectionData = data
    },
    saveNewSectionDataData: (state, data) => {
        state.newSectionData = data
    },
    saveOldSectionPPtData: (state, data) => {
        state.oldSectionPPtData = data
    },
    saveNewSectionPPtData: (state, data) => {
        state.newSectionPPtData = data;
    },
    saveAdjustmentSaveFlag: (state, data) => {
        state.adjustmentSaveFlag = data
    },
    saveTarget: (state, targetList) => {
        state.targetList = targetList
    },
    clearTarget: (state) => {
        state.targetList = [];
    },
    saveMTeachingDesignId: (state, data) => {
        state.mTeachingDesignId = data;
    },
    saveDefaultTargetListByPrivate: (state, data) => {
        state.defaultTargetListByPrivate = data;
    },
    clearMTeachingDesignId: (state) => {
        state.mTeachingDesignId = '';
    },
    clearDefaultTargetListByPrivate: (state) => {
        state.defaultTargetListByPrivate = [];
    },
    saveReferenceFlag: (state, data) => {
        state.referenceFlag = data;
    },
    saveAdjustmentFlag: (state, data) => {
        state.adjustmentFlag = data;
    },
    clearKnowledgePoints: (state) => {
        state.knowledgePoints = [];
    },
    saveOtherCourseFlag: (state, data) => {
        state.otherCourseFlag = data;
    },
    changeHiddenFlag: (state, data) => {
        state.hiddenFlag = data
    },
    changeGiveLessonsFlag: (state,data) => {
      state.giveLessonsFlag = data
    }
}
const getters = {
    getMaxSequence: (state) => (activeSectionIndex) => {
        let maxSequence = 1;
        if(state.param.sectionArr[activeSectionIndex] && state.param.sectionArr[activeSectionIndex].items && state.param.sectionArr[activeSectionIndex].items.length){
            maxSequence = state.param.sectionArr[activeSectionIndex].items[0].css["z-index"];
            for(let i=1;i<state.param.sectionArr[activeSectionIndex].items.length;i++){
                if(maxSequence < state.param.sectionArr[activeSectionIndex].items[i].css["z-index"]){
                    maxSequence = state.param.sectionArr[activeSectionIndex].items[i].css["z-index"];
                }
            }
            maxSequence += 1;
        }
        return maxSequence;
    }
}

export default {
    state,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/d000103.js